import * as R from "ramda";
import * as React from "react";
import { FieldSetToggleDisplay } from "../../../../App/Common/Components/FormComponents";
import { fullCourseViews } from "../../../../utils/courseViews";
import { PreferredLocale } from "../../../../utils/locales";
import { HTMLEditor } from "../../../course-author/html-editor/Editor.container";
import { HTMLRenderer } from "../../../course-author/html-editor/Renderer";
import { ICourseEditOperations, IFullCourse } from "../../../course-author/types";

export interface IEditCourseDescriptionProps {
  course: IFullCourse;
  editOperations: ICourseEditOperations;
  currentLocale: PreferredLocale;
}

export interface IEditCourseDescriptionState {
  description: string;
  edit: boolean;
}

export default class EditCourseDescription extends React.Component<
  IEditCourseDescriptionProps,
  IEditCourseDescriptionState
> {
  public containerRef = React.createRef<HTMLDivElement>();
  constructor(props: IEditCourseDescriptionProps) {
    super(props);
    this.state = {
      description: this.getDescription(),
      edit: false,
    };
  }

  public componentDidUpdate(oldProps: IEditCourseDescriptionProps) {
    if (oldProps.currentLocale !== this.props.currentLocale) {
      this.setState({ description: this.getDescription(), edit: false });
    }
  }

  public getDescription = () => fullCourseViews.localizedDescription(this.props.course, this.props.currentLocale) || "";

  public getMarkdown = () => this.state.description;

  public toggleEdit = () => this.setState({ edit: !this.state.edit });

  public submitDescription = (description: string) => {
    const { addCourseDescription, modifyCourseDescription } = this.props.editOperations;
    const currentDescription = fullCourseViews.localizedDescription(this.props.course, this.props.currentLocale);

    if (description === currentDescription) {
      return this.toggleEdit();
    }

    if (R.isNil(currentDescription)) {
      addCourseDescription(description);
    } else {
      modifyCourseDescription(description);
    }

    this.setState({ description });
    this.toggleEdit();
  };

  public render() {
    return (
      <div ref={this.containerRef} data-testid="editor-container">
        {!this.state.edit && (
          <FieldSetToggleDisplay
            legend={"Course Description:"}
            onClick={this.toggleEdit}
            shouldDisplay={!this.state.edit}
          >
            <HTMLRenderer placeholder={"Type here"} source={this.state.description} />
          </FieldSetToggleDisplay>
        )}
        {this.state.edit && (
          <HTMLEditor
            getContent={this.getMarkdown}
            setContent={this.submitDescription}
            shouldAutoFocus={false}
            currentLocale={this.props.currentLocale}
            containerRef={this.containerRef}
            toggleEdit={this.toggleEdit}
          />
        )}
      </div>
    );
  }
}
